/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum OpportunityStageCode {
  Develop = "0a",
  Validate = "0b",
  Intake = "0c",
  Craft = "1",
  Compete = "2",
  Contract = "3",
  ClosedLost = "L",
  ClosedWon = "W",
}

export const OpportunityStageCodeDisplay: Record<OpportunityStageCode, string> = {
  [OpportunityStageCode.Develop]: "0a",
  [OpportunityStageCode.Validate]: "0b",
  [OpportunityStageCode.Intake]: "0c",
  [OpportunityStageCode.Craft]: "1",
  [OpportunityStageCode.Compete]: "2",
  [OpportunityStageCode.Contract]: "3",
  [OpportunityStageCode.ClosedLost]: "L",
  [OpportunityStageCode.ClosedWon]: "W",
};
